import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialArticle8State from './initialState';

const article8Slice = createSlice({
  name: 'article8',
  initialState: initialArticle8State(),
  reducers: {
    setSelectedSystem(state, action: PayloadAction<string>) {
      state.selectedSystem = action.payload;
    },
  },
});
export const { setSelectedSystem } = article8Slice.actions;

export default article8Slice;
